$('input[name=num_partitions]').on('change', ({ target }) => {
  const button = $(target).siblings('.btn[data-action=create-all]')
  const link = button.prop('href')
    .replace(/num_partitions=\d+/, `num_partitions=${$(target).val()}`);
  button.prop('href', link);
})
